import { tv, type VariantProps } from 'tailwind-variants'

export const buttonCommonVariants = tv({
  base: [
    'flex',
    'flex-row',
    'items-center',
    'self-center',
    'justify-content',
    'justify-center',
    'rounded-full',
    'min-w-0',
    'h-auto',
    'overflow-hidden',
  ],
  variants: {
    size: {
      xs: 'gap-1 px-2',
      sm: 'gap-1 px-3',
      md: 'gap-2 px-4',
      lg: 'gap-2 px-6',
    },
    isIconOnly: {
      true: 'native:px-0',
    },
    isDisabled: {
      true: 'opacity-50',
      false: 'opacity-100',
    },
    isLoading: {
      true: 'opacity-100',
    },
  },
  defaultVariants: {
    isIconOnly: false,
    size: 'md',
  },
  compoundVariants: [
    {
      isIconOnly: true,
      size: 'xs',
      class: 'h-8 w-8',
    },
    {
      isIconOnly: false,
      size: 'xs',
      class: 'min-h-8',
    },
    {
      isIconOnly: true,
      size: 'sm',
      class: 'h-10 w-10',
    },
    {
      isIconOnly: false,
      size: 'sm',
      class: 'min-h-10',
    },
    {
      isIconOnly: true,
      size: 'md',
      class: 'h-12 w-12 min-w-12',
    },
    {
      isIconOnly: false,
      size: 'md',
      class: 'min-h-12',
    },
    {
      isIconOnly: true,
      size: 'lg',
      class: 'h-14 w-14 min-w-14',
    },
    {
      isIconOnly: false,
      size: 'lg',
      class: 'min-h-14',
    },
  ],
})

export type TCommonButtonVariantProps = VariantProps<typeof buttonCommonVariants>
